module.exports = __webpack_public_path__ + "img/solutz_logo_white_horizontal.a38c1ca2.svg";